import { render, staticRenderFns } from "./Input_Wysiwyg.vue?vue&type=template&id=5390c70e&scoped=true&"
import script from "./Input_Wysiwyg.vue?vue&type=script&lang=js&"
export * from "./Input_Wysiwyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390c70e",
  null
  
)

export default component.exports